import * as Countries from '../../../config/countries';
import { Country } from './type';

export function getCountryConfigFromCode(country_code: string): Country | null {
  if (!country_code) return null;
  const key = country_code.toLowerCase() as keyof typeof Countries;
  return key in Countries ? Countries[key] : null;
}
